<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="accordion-class">
  <h5>Trucks Type</h5>
  <mat-divider></mat-divider>
</div>
<form [formGroup]="truckTypeForm" class="admin-forms admin-type truckComponent">
  <div class="input-fileds-container">
    <div class="group">
      <mat-form-field>
        <mat-label>Weight</mat-label>
        <input
          matInput
          type="number"
          formControlName="truck_weight"
          (wheel)="disableScroll($event)"
          required
        />
        <!-- <mat-error>Truck Weight is required</mat-error> -->
        <mat-error
          *ngIf="truckTypeForm.get('truck_weight')?.hasError('required')"
        >
          Truck Weight is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="group mt-2">
      <mat-form-field>
        <mat-label>Feet</mat-label>
        <input
          matInput
          type="number"
          formControlName="truck_feet"
          (wheel)="disableScroll($event)"
          required
        />
        <mat-error>Truck Feet is required</mat-error>
      </mat-form-field>
    </div>
    <div class="group mt-2">
      <mat-form-field>
        <mat-label>Wheels</mat-label>
        <input
          matInput
          type="number"
          formControlName="minimum_amount"
          (wheel)="disableScroll($event)"
          required
        />
        <mat-error>Truck Wheels is required</mat-error>
      </mat-form-field>
    </div>
    <div class="group mt-2 driver-truck">
      <mat-form-field appearance="fill">
        <mat-select formControlName="truck_category_id">
          <mat-option value="">Select Category</mat-option>
          <mat-option *ngFor="let item of CategoryList" value="{{ item._id }}"
            >{{ item.truck_category_name }}
          </mat-option>
        </mat-select>
        <mat-error>Category is required</mat-error>
      </mat-form-field>
    </div>
    <div class="group mt-2">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input matInput formControlName="truck_type_description" required />
        <mat-error>Truck Description is required</mat-error>
      </mat-form-field>
    </div>
    <div class="group mt-2">
      <mat-form-field>
        <mat-label>Speed Limit</mat-label>
        <input
          matInput
          type="number"
          formControlName="spped_limit"
          (wheel)="disableScroll($event)"
          required
        />
        <mat-error>Speed Limit is required</mat-error>
      </mat-form-field>
    </div>
    <div class="group"></div>
    <div class="image-upload-view-area">
      <div [class.spinner]="typeImageloading"></div>

      <div class="upload_image">
        <img *ngIf="truckImg" src="{{ truckImage }}" class="upload_img_size" />
      </div>
      <div class="image-upload-area mt-3">
        <span *ngIf="uploadImg" (click)="uploadImage.click()" class="image"
          ><img src="../../../assets/img/upload.svg" />
          <p>Upload Truck Image</p>
        </span>
        <img
          src="../../../assets/img/cross.svg"
          *ngIf="crossImg"
          (click)="removeImg()"
          class="cross-btn"
          alt=""
        />
        <input #uploadImage type="file" (change)="onChange($event)" hidden />
      </div>
    </div>
  </div>
  <!-- <i class="fa fa-spinner fa-spin"></i> -->
  <button
    type="button"
    class="button buttonBlue"
    [class.spinner]="typeImageloading"
    [ngClass]="{ 'button-disabled': typeImageloading || !truckTypeForm.valid }"
    [disabled]="typeImageloading || !truckTypeForm.valid"
    (click)="onSubmitType($event)"
    *ngIf="!editTruckType"
  >
    Submit
  </button>
  <button
    type="button"
    class="button buttonBlue"
    [class.spinner]="typeImageloading"
    [ngClass]="{ 'button-disabled': typeImageloading || !truckTypeForm.valid }"
    [disabled]="typeImageloading || !truckTypeForm.valid"
    (click)="onEditType($event)"
    *ngIf="editTruckType"
  >
    Submit
  </button>
</form>
